import React, { Component, useEffect, useState } from "react";
import "../../Assets/css/myaccount.css";
import {
  Breadcrumbs,
  CircularProgress,
  Dialog,
  List,
  Typography,
} from "@material-ui/core";
import {
  Col,
  Container,
  Row,
  ProgressBar, DropdownButton, Dropdown,
  Modal,
  Form,
  Image,
  Button,
} from "react-bootstrap";
import { SideBySideMagnifier } from "react-image-magnifiers";
import ImageGallery from "react-image-gallery";
import "../../Assets/css/productDetails.css";
import "../../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import { TextField, Rating, Skeleton } from "@mui/material";
import axios from "axios";
import {
  base_url,
  client_name,
  ErrorImg,
  postHeader,
} from "../../Helpers/request";
import { toast } from "react-toastify";
import Videoimg from "../../Assets/images/example-360video-thumb.jpg";
import moment from "moment";
import {
  ProductAppoitnment,
  ProductEnquiry,
  ReturnModal,
  ShippingModal,
} from "../../Components/Modals";
import { Helmet } from "react-helmet";
import Ringbildermenu from "../../Components/ringbildermenu";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { isDesktop, isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { NavLink, useParams, useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import cart from "../../Assets/images/cart.png";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import inquir from "../../Assets/images/inquir.svg";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Engraving from "../../Components/engraving";
import rose_metal from "../../Assets/images/icon/metal_rg.webp";
import yellow_metal from "../../Assets/images/icon/metal_yg.webp";
import white_metal from "../../Assets/images/icon/metal_wg.webp";
import { store } from "../../Store/store";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { Wishlengthvalue } from "../../Reducer/wishlistReducer";
import { sessionId, Setuser } from "../../Reducer/homeReducer";
import ShopStyle from "../../Assets/css/RingDiamondShop.module.css";
import { Link } from "react-router-dom/cjs/react-router-dom";
import copy from "copy-to-clipboard";
import ShareIcons from "../../Components/ShareIcons";
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import '../../Assets/css/product_detail_tileview.css';
import DragAndDropDiv from "./productViewChange";
import { useDispatch, useSelector } from "react-redux";
function ProductdetailsFunctionComponent (){

  const dispatch = useDispatch()
  const match = useParams()
    const [showFilter, setShowFilter] = useState(true);
    const [images, setImages] = useState([]);
    const [currentImageUrl, setCurrentImageUrl] = useState([]);
    const [currentVideoUrl, setCurrentVideoUrl] = useState("");
    const [currentImagetype, setCurrentImagetype] = useState(null);
    const [currencies, setCurrencies] = useState([
      { value: "Round", label: "Round" },
      { value: "Round Cut", label: "Round Cut" },
      { value: "Round1", label: "Round1" },
      { value: "Round2", label: "Round2" },
    ]);

    const [isWish, setIsWish] = useState(false);
    const [product_id, setProduct_id] = useState("");
    const [currency, setCurrency] = useState(false);
    const [showProductView, setShowProductView] = useState(false);
    const [value, setValue] = useState("5");
    const [shipping, setShipping] = useState(false);
    const [returnState, setReturnState] = useState(false);
    const [review, setReview] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [productDetailsdata, setProductDetailsdata] = useState([]);
    const [reviewData, setReviewData] = useState([]);
    const [slug, setSlug] = useState(match?.slug);
    const [rating, setRating] = useState("");
    const [comment, setComment] = useState("");
    const [ringSize, setRingSize] = useState(0);
    const [engravingshow, setEngravingshow] = useState(false);
    const [notify, setNotify] = useState(false);
    const [ringSizeAvailable, setRingSizeAvailable] = useState(false);
    const [loader, setLoader] = useState(true);
    const [shippingTerm, setShippingTerm] = useState([]);
    const [openButton, setOpenButton] = useState(false);
    const [inquiry, setInquiry] = useState(false);
    const [listData, setlistData] = useState([]);
    const [proIndex, setProIndex] = useState(null);
    const [engraving, setEngraving] = useState("");
    const [textStyle, setTextStyle] = useState("great_vibes");
    const [metalColor, setMetalColor] = useState("");
    const [tabValue, setTabValue] = useState("2");
    // const [paramId, setParamId] = useState(
    //   match?.listcategory
    //     ? match.listcategory
    //     : match.search_text
    // );
    
    const [serviceModel, setServiceModel] = useState(false);
    const [modelIndex, setModelIndex] = useState(null);
    const [eng_color, setEng_color] = useState(null);
    const history = useHistory();
    const user = useSelector((state) =>state.persistedReducer.home.userData);
    const session_Id = useSelector(state =>state.persistedReducer.home.session_id);
    const currencycode = useSelector(
      (state) =>state.persistedReducer.home.currencycode
    );
    //  img new magnifire left 
  
  
    // const [paramid, setParamid] = useState();
  
    useEffect(() => {
      productdetails();
      filterApi()
      shippingterm();
      setLoader(true);
    }, []);
  // const [productView, setProductView] = useState(false)
    const toggleProductView = () => {
      setShowProductView((prevState) => !showProductView);
    };
  
  const shippingterm = () => {
    axios
      .get(base_url + "/order/shipping_options", {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setShippingTerm(res.data.data);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const filterApi = () => {
    const data = {
      currency_code: currencycode,
      slug:slug,
    };
    axios
      .post(base_url + "/product/productdetailfilter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFilterData(res.data.data)
          res.data.data.map((val) => {
            if (val.title == "Ring Size") {
              setRingSizeAvailable(true)
            }
          });
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
const productdetails = () => {
    if (!isWish) {
      setLoader(false)
    }
    const data = {
      currency_code:currencycode,
      slug:slug,
      selecteddata: filterData,
      user_id: user?.user_id ? user?.user_id : "",
      session_id: session_Id ? session_Id : "",
    };
    axios
      .post(base_url + "/product/productdetail", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          similarProduct(res.data.data[0]);
          if (match.id == "setting") {
            history.push(
              "/ringsettingdetail/setting/" + res.data.data[0].slug
            );
          } else {
            history.push("/productdetail/" + res.data.data[0].slug);
          }
          getReview(res.data.data[0]?.product_id);
          var arr = [];
          setSlug(res.data.data[0].slug);
          setMetalColor(res.data.data[0]?.metal_color);
          setProductDetailsdata(res.data.data[0]);
          setCurrentImageUrl(res.data.data[0]?.product_image[0]?.url);
          setCurrentImagetype(res.data.data[0]?.product_image[0]?.type);
          res.data.data[0]?.product_image?.map((val) => {
            if (val.type == "2") {
              var obj = {
                original: val.url,
                thumbnail: Videoimg,
                type: val.type,
              };
              arr.push(obj);
            }else if(val.type == "3"){
              var obj = {
                original: val.url,
                thumbnail: Videoimg,
                type: val.type,
              };
              arr.push(obj);
            } else {
              var obj = {
                original: val.url,
                thumbnail: val.url,
                type: val.type,
              };
              arr.push(obj);
            }
          });
          setImages(arr);
          setLoader(false)

          // filterApi();
        } else if (res.data.status == 2) {
         dispatch(Setuser([]));
         dispatch(Wishlengthvalue());
         dispatch(cartlengthvalue(0));
         dispatch(sessionId(""));
          history.push("/");

        } else {
          history.push("/page-not-found");
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const similarProduct = (prodata) => {
    const data = {
      currency_code: currencycode,
      product_id: prodata?.product_id,
      metal_color: prodata?.metal_color,
      category: prodata?.category_slug,
      user_id: user?.user_id || "",
      session_id: session_Id ? session_Id : "",
    };
    axios
      .post(base_url + "/product/relatedproduct", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setlistData(res.data.data?.result || []);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const addtowishlist = (productId, wishIndex, id) => {
    setIsWish(true);
    const data = {
      currency_code: currencycode,
      user_id: user?.user_id || "",
      session_id: session_Id ? session_Id : "",
      product_id: productId,
      type: "JEWELRY",
      token: user?.isLogin ? user?.token : "",
    };
    axios
      .post(`${base_url}/order/add_to_wishlist`, data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          if (id) {
            const updatedList = listData.map((obj, index) =>
              index === wishIndex
                ? { ...obj, is_wishlist: res.data.data.wishlist_id }
                : obj
            );
            setlistData(updatedList);
          } else {
            productdetails();
          }
          toast.success(res.message, { autoClose: 3000 });
          dispatch(Wishlengthvalue(res.data.data.count));
        } else if (res.data.status === 2) {
          // handleSessionExpiry();
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => console.error(error));
  };

  const onchangeselect = (value, title) => {
    var changedata = [...filterData];
    changedata = changedata.map((obj) =>
      obj.title == title
        ? Object.assign(obj, { selected: value })
        : obj
    );
    setFilterData(changedata );
    productdetails(title);
  };
  const getReview = (productId) => {
    const data = {
      currency_code: currencycode,
      product_id: productId,
    };
    axios
      .post(`${base_url}/product/reviews_list`, data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setReviewData(res.data.data);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => console.error(error));
  };

  const addtocart = (productId, id) => {
    
    if (id === 1 && ringSize <= 0 && ringSizeAvailable) {
      setNotify(true)
      toast.warn("Please select a ring size.",{ autoClose: 1000});
    } else {
      const data = {
        currency_code: currencycode,
        user_id: user?.user_id || "",
        session_id: session_Id ? session_Id : "",
        product_id: productId,
        quantity: "1",
        ring_size: ringSize,
        engraving_text: engraving,
        engraving_font: textStyle,
        token: user?.isLogin ? user?.token : "",
        type: "jewelry",
      };
      axios
        .post(`${base_url}/order/add_to_cart`, data, {
          headers: postHeader,
        })
        .then((res) => {
          if (res.data.status === 1) {
            dispatch(cartlengthvalue(res.data.data.total_count));
            toast.success(res.data.message, { 
              autoClose: 1000,
              onClick: () => {
                // Add your custom click logic here
                history.push("/cart")
              }
            });
          } else if (res.data.status === 2) {
            // handleSessionExpiry();
          } else {
            toast.error(res.data.message, { autoClose: 1000 });
          }
        })
        .catch((error) => console.error(error));
    }
  };
  

  const submitReview = () => {
    
    const data = {
      currency_code: currencycode,
      user_id: user?.user_id,
      token: user?.token,
      rating,
      review: comment,
      product_id: productDetailsdata?.product_id,
    };
    axios
      .post(`${base_url}/product/add_review`, data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          getReview(data.product_id);
          setComment("");
          setRating("");
        } else if (res.data.status === 2) {
          // handleSessionExpiry();
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => console.error(error));
  };
  const [appointment, setAppointment] = useState(false)
  const handleShowInquiry = () => setInquiry(true);
  const handleCloseInquiry = () => setInquiry(false);
  const handleCloseShipping = () => setShipping(false);
  const handleShowShipping = () => setShipping(true);
  const handleCloseReturn = () => setReturnState(false);
  const handleShowReturn = () => setReturnState(true);
  const handleShowAppointment = () => setAppointment(true);
  const handleCloseAppointment = () => setAppointment(false);
  const handleCloseReview = () => setReview(false);
  const handleShowReview = () => setReview(true);
  const handleOpenButton = () => {
    if (ringSize == 0 && ringSizeAvailable) {
      setNotify(true)
      // setInterval(() => {  setState({ notify: false }) }, 3000);
    } else {
      setOpenButton(true);
    }
  };
  const handleCloseButton = () => setOpenButton(false);

  const setView = (event, index) => {
    setCurrentImageUrl(images[index].original)
    setCurrentImagetype(images[index].type)
  };
  const selectSetting = () => {
    if (ringSize == 0 && ringSizeAvailable) {
      setNotify(true);
      // setInterval(() => {  setNotify(false) }, 3000);
    } else {
      const data = {
        currency_code: currencycode,
        product_id: productDetailsdata?.product_id,
        slug: productDetailsdata?.slug,
        image:productDetailsdata?.product_image[0]?.url,
        price: productDetailsdata?.sale_price,
        ring_size: ringSize,
        name: productDetailsdata?.name,
        engraving_text: engraving,
        engraving_font: textStyle,
      };
      localStorage.setItem(
        "bw-step",
        JSON.parse(localStorage.getItem("bw-gemstonedata") == null) &&
          JSON.parse(localStorage.getItem("bw-diamonddata") == null) &&
          JSON.parse(localStorage.getItem("bw-fancycolordata") == null)
          ? "setting"
          : "stone"
      );
      localStorage.setItem("bw-settingdata", JSON.stringify(data));
      if (JSON.parse(localStorage.getItem("bw-gemstonedata") != null)) {
        history.push("/complete-gemstone-ring");
      } else if (JSON.parse(localStorage.getItem("bw-diamonddata") != null)) {
        history.push("/complete-diamond-ring");
      } else if (
        JSON.parse(localStorage.getItem("bw-fancycolordata") != null)
      ) {
        history.push("/complete-fancycolor-ring");
      }
    }
  };
  const engravingfunc = (e) => {
    // set[e.target.name]: e.target.value
     };
 

    var settings2 = {
      dots: false,
      infinite: true,
      speed: 500,
      accessibility: true,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      centerPadding: "60px",
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const copyToClipboard = (url) => {
      let copyText = url;
      let isCopy = copy(copyText);
      if (isCopy) {
        toast.success("Copied to Clipboard", { autoClose: 3000 });
      }

    };
   let average = 0
  const average1 = reviewData?.rating_count?.map((val) =>
    val.rating == 5 ? (average = val.average) : ""
  );
  const step = JSON.parse(sessionStorage.getItem("bw-step"))
    ? JSON.parse(sessionStorage.getItem("bw-step"))
    : [3, 1];
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{productDetailsdata?.meta_title}</title>
          <meta
            name="description"
            content={productDetailsdata?.meta_desp}
          ></meta>
          <meta
            name="keywords"
            content={productDetailsdata?.meta_keywords}
          ></meta>
        </Helmet>
        {
         productDetailsdata?.category_name == "Engagement Rings"
            ? ""
            : // <div className={ShopStyle.BannerTop}>
            //   <h3 className={ShopStyle.subTitle}>Design Your Own</h3>
            //   <h2 className={ShopStyle.Title}>Diamond Ring</h2>
            //   <ul className={ShopStyle.BreadcrumbS}>
            //     <li><NavLink to='/'>Home</NavLink></li>
            //     <li>/</li>
            //     <li><NavLink
            //       to={
            //         props.match.params.id == "setting"
            //           ? (step == JSON.stringify(step)) == "[2,3]" ||
            //             JSON.stringify(step) == "[3,2]"
            //             ? "/ringsettings/gemstones"
            //             : JSON.stringify(step) == "[0,3]" ||
            //               JSON.stringify(step) == "[3,0]"
            //               ? "/ringsettings/fancycolor"
            //               : "/ringsettings/diamonds"
            //           : "/jewelry/" +productDetailsdata?.category_slug
            //       }
            //     >
            //       {productDetailsdata?.category_name}
            //     </NavLink></li>
            //     <li>/</li>
            //     <li>
            //       {productDetailsdata?.name}
            //     </li>
            //   </ul>
            // </div> :
            ""
          //   <div className={ShopStyle.BannerTop}>
          //   {/* <h3 className={ShopStyle.subTitle}>Design Your Own</h3> */}
          //   <h2 className={ShopStyle.Title}>{productDetailsdata?.name}</h2>
          //   <ul className={ShopStyle.BreadcrumbS}>
          //     <li><NavLink to='/'>Home</NavLink></li>
          //     <li>/</li>
          //     <li><NavLink
          //       to={
          //         props.match.params.id == "setting"
          //                   ? (step == JSON.stringify(step)) == "[2,3]" ||
          //                     JSON.stringify(step) == "[3,2]"
          //                     ? "/ringsettings/gemstones"
          //                     : JSON.stringify(step) == "[0,3]" ||
          //                       JSON.stringify(step) == "[3,0]"
          //                     ? "/ringsettings/fancycolor"
          //                     : "/ringsettings/diamonds"
          //                   : "/jewelry/" +productDetailsdata?.category_slug
          //               }
          //     >
          //       {productDetailsdata?.category_name}
          //     </NavLink></li>
          //     <li>/</li>
          //     <li>
          //       {productDetailsdata?.name}
          //     </li>
          //   </ul>
          // </div>
          //  <Container fluid
          //     className={
          //       props.match.params.id == "setting"
          //         ? "rcs_shap-wizard_container"
          //         : " pl-5 pt-3"
          //     }
          //   >
          //     <Row>
          //       <Col className="rcs_breadcrumb mb-2">
          //         <Breadcrumbs aria-label="breadcrumb">
          //           <NavLink underline="hover" color="inherit" to="/">
          //             Home
          //           </NavLink>
          //           <NavLink
          //             underline="hover"
          //             color="inherit"
          //             to={
          //               props.match.params.id == "setting"
          //                 ? (step == JSON.stringify(step)) == "[2,3]" ||
          //                   JSON.stringify(step) == "[3,2]"
          //                   ? "/ringsettings/gemstones"
          //                   : JSON.stringify(step) == "[0,3]" ||
          //                     JSON.stringify(step) == "[3,0]"
          //                   ? "/ringsettings/fancycolor"
          //                   : "/ringsettings/diamonds"
          //                 : "/jewelry/" +productDetailsdata?.category_slug
          //             }
          //           >
          //             {productDetailsdata?.category_name}
          //           </NavLink>
          //           <Typography color="text.primary">
          //             {productDetailsdata?.name}
          //           </Typography>
          //         </Breadcrumbs>
          //       </Col>
          //     </Row>
          //   </Container>
        }

        {/* {loader ? (
          <div className="rcs_filter_wrapper">
            {props.match.params.id == "setting" ? (
              <CircularProgress className="rcs_filter_loader rcs_filter_loader1" />
            ) : (
              <CircularProgress className="rcs_filter_loader" />
            )}
          </div>
        ) : (
          ""
        )} */}
        <div className="rcs_ringsetting_section mt-3">
          {match.id == "setting" ? (
            <Ringbildermenu location="setting" />
          ) : (
            ""
          )}
        </div>
            {/* <DragAndDropDiv/> */}
        <div className="rcs_product_details">
          <Container fluid className="showcase-container">
            {/* {isDesktop && <Button onClick={toggleProductView} variant="none" className="productViewBtn">{showProductView ? "Slide View" : "Tile View"} </Button>} */}
            <Row>
              {showProductView && isDesktop ?
                <Col sm={12} md={12} lg={6} xl={6}>
                  <Row className="m-0 Zoom_effact_image_tileView">
                    {images?.map((val) =>
                      val.type == 1 ? (
                        <Col sm={6} md={6} lg={6} xl={6} className="pl-1 pr-1">
                          <InnerImageZoom src={val.original} zoomSrc={val.original} imgAttributes={{ alt: val?.name }} />
                        </Col>
                      ) : val.type == 2 ? (
                        <Col sm={6} md={6} lg={6} xl={6} className="pl-1 pr-1">
                          <div className="video-wrapper">
                            <video style={{ width: "100%", height: "auto !important" }}
                              src={val.original}
                              frameBorder="0"
                              allowFullScreen
                              playsinline="true"
                              autoPlay="true"
                              muted="true"
                              loop
                            ></video>
                          </div>
                        </Col>
                      ) :
                      (
                        <Col sm={6} md={6} lg={6} xl={6} className="pl-1 pr-1">
                        <div className="video-container">
                        <iframe src={val?.original} />
                      </div>
                      </Col>
                      )
                    )}
                  </Row>
                </Col> :
                <Col
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  className="rcs_large_tablet"
                >
                  {isMobile ? (
                    <Slider {...settings}>
                      {images?.map((val) =>
                        val.type == 1 ? (
                          <div>
                            <Image src={val?.original} alt=""></Image>
                          </div>
                        ) :  val.type == 3 ? 
                        <div className="video-container">
                            <iframe src={val?.original} />
                          </div>
                        :  (
                          <div>
                            <div className="video-wrapper">
                              <video
                                src={val?.original}
                                frameBorder="0"
                                allowFullScreen
                                playsinline="true"
                                autoPlay="true"
                                muted="true"
                                loop
                              ></video>
                            </div>
                          </div>
                        )
                      )}
                      {/* )} */}
                    </Slider>
                  ) : (
                    <div className="magnify-Image m-auto">
            
                      {/* <Row className="align-items-center"> */}
                      <Row>
                        <Col sm={2} className="">
                          <ImageGallery
                            items={images}
                            onThumbnailClick={setView}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            showNav={false}
                            onImageError={() => ErrorImg("none",productDetailsdata?.slug, "detail")}
                          />
                          {/* {videos?.map((val,index) => 
                                            <button onClick={(e)=> setViewvideo(e,index)} type="button" className= {currentImagetype == 1 ? "image-gallery-thumbnail " : "image-gallery-thumbnail active"}>
                                                <span class="image-gallery-thumbnail-inner">
                                                    <video class="image-gallery-thumbnail-image" src={Videoimg} />
                                                        </span>
                                                        </button> 
                                            )} */}
                        </Col>
                        <Col sm={10}>
                          {currentImagetype == 1 ? (
                            <SideBySideMagnifier
                              alwaysInPlace={false}
                              className="image-to-magnify"
                              fillAvailableSpace={false}
                              imageSrc={currentImageUrl}
                              largeImageSrc={currentImageUrl}
                            />
                          ) : currentImagetype == 3 ? (
                            <div className="video-container">
                            <iframe src={currentImageUrl} />
                          </div>
                          ) : (
                            <div className="video-wrapper">
                              <video
                                width="540"
                                height="540"
                                src={currentImageUrl}
                                frameBorder="0"
                                allowFullScreen
                                playsinline="true"
                                autoPlay="true"
                                loop
                              ></video>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                </Col>}
              <Col sm={12} md={12} lg={6} xl={6} className="rcs_large_tablet">
                <div className="ml_product_content">
                  {loader ? (
                    <div className="rcs_content_block">
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={290}
                          height={45}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={500}
                          height={45}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={350}
                          height={45}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={210}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={80}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={500}
                          height={100}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={130}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {/* <div className="rcs_product_btn">
                                                <ul className='d-flex justify-content-between'>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={165} height={35} />}</li>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px', marginBottom: '5px' }} width={165} height={35} />}</li>
                                                </ul>
                                            </div> */}
                      <div className="rcs_social">
                        <ul>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="rcs_content_block w-100">
                      <div className="rcs_product_sku d-flex justify-content-between align-items-center mb-xs-0">
                        <p>SKU :{productDetailsdata?.sku}</p>
                        <span>
                          {productDetailsdata?.is_wishlist == 0 ? (
                            <Button
                              variant="none"
                              onClick={() =>
                                addtowishlist(
                                 productDetailsdata?.product_id
                                )
                              }
                              className="shadow-none p-0"
                            >
                              <svg
                                width="50"
                                height="50"
                                viewBox="0 0 86 86"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g filter="url(#filter0_d_1_256)">
                                  <circle cx="43" cy="43" r="23" fill="white" />
                                </g>
                                <path
                                  d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z"
                                  stroke="var(--primary)"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <defs>
                                  <filter
                                    id="filter0_d_1_256"
                                    x="0"
                                    y="0"
                                    width="86"
                                    height="86"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                  >
                                    <feFlood
                                      flood-opacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                      in="SourceAlpha"
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                      result="hardAlpha"
                                    />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="10" />
                                    <feComposite
                                      in2="hardAlpha"
                                      operator="out"
                                    />
                                    <feColorMatrix
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in2="BackgroundImageFix"
                                      result="effect1_dropShadow_1_256"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in="SourceGraphic"
                                      in2="effect1_dropShadow_1_256"
                                      result="shape"
                                    />
                                  </filter>
                                </defs>
                              </svg><span className="d-none">wishlist</span>
                            </Button>
                          ) : (
                            <Button
                              onClick={() =>
                                addtowishlist(
                                 productDetailsdata?.product_id
                                )
                              }
                              variant="none"
                              className="shadow-none p-0"
                            >
                              <svg
                                width="50"
                                height="50"
                                viewBox="0 0 86 86"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g filter="url(#filter0_d_1_259)">
                                  <circle
                                    cx="43"
                                    cy="43"
                                    r="23"
                                    fill="var(--primary)"
                                  />
                                </g>
                                <path
                                  d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z"
                                  fill="white"
                                />
                                <defs>
                                  <filter
                                    id="filter0_d_1_259"
                                    x="0"
                                    y="0"
                                    width="86"
                                    height="86"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                  >
                                    <feFlood
                                      flood-opacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                      in="SourceAlpha"
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                      result="hardAlpha"
                                    />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="10" />
                                    <feComposite
                                      in2="hardAlpha"
                                      operator="out"
                                    />
                                    <feColorMatrix
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in2="BackgroundImageFix"
                                      result="effect1_dropShadow_1_259"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in="SourceGraphic"
                                      in2="effect1_dropShadow_1_259"
                                      result="shape"
                                    />
                                  </filter>
                                </defs>
                              </svg><span className="d-none">wishlist</span>
                            </Button>
                          )}

                        </span>
                      </div>
                      <div className="rcs_product_heading">
                        <h1 className="pr-4">
                          {productDetailsdata?.name}
                        </h1>
                      </div>

                      {productDetailsdata?.is_price == 1 ? (
                        <div className="rcs_price">
                          <h4>
                            {productDetailsdata?.currency_icon}
                            {productDetailsdata?.sale_price}
                          </h4>
                        </div>
                      ) : (
                        <div className="rcs_email">
                          <span>Email us for Price</span>
                        </div>
                      )}
                      <div className="rcs_content_details">
                        <p>{productDetailsdata?.description}</p>
                      </div>
                      <hr className="hrRingSetting" />

                      <div className="rcs_filter rcs_add_address">
                        <Row>
                          {filterData?.map(
                            (val) =>
                              val?.title === "Material" ||
                                val?.title === "Shape" ? (
                                <Col
                                  md={12}
                                  className={
                                    val?.title === "Shape" ? "order-first" : ""
                                  }
                                >
                                  <p className="selectedOptions">
                                    <span>{val?.title} :</span> {val.selected}
                                  </p>
                                  <div className="ShowcaseRingseting_ProdFilterMain">
                                    <ul className="ShowcaseRingseting_ProdFilter">
                                      {val?.data?.map((option) => (
                                        <li
                                          className={
                                            val.selected == option.value
                                              ? "active"
                                              : ""
                                          }
                                          onClick={() =>
                                            onchangeselect(
                                              option.value,
                                              val?.title
                                            )
                                          }
                                        >
                                          {/* <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z" fill="url(#paint0_linear_806_1776)" />
                                          <path d="M9.78 20.435V18.05H13.935V29H11.265V20.435H9.78ZM15.7496 27.05V24.98L20.4896 18.2H23.3546V24.83H24.5846V27.05H23.3546V29H20.7896V27.05H15.7496ZM20.9696 21.02L18.4496 24.83H20.9696V21.02ZM32.201 29L28.661 24.35V29H26.096V18.47H28.661V23.09L32.171 18.47H35.186L31.106 23.63L35.336 29H32.201Z" fill="#BF977C" />
                                          <defs>
                                            <linearGradient id="paint0_linear_806_1776" x1="36.75" y1="4.5" x2="9.375" y2="41.625" gradientUnits="userSpaceOnUse">
                                              <stop stop-color="#EBCBB6" />
                                              <stop offset="0.505208" stop-color="white" />
                                              <stop offset="1" stop-color="#EBCBB6" />
                                            </linearGradient>
                                          </defs>
                                        </svg> */}
                                          {option.icon && (
                                            <img src={option.icon} alt={option.name} />
                                          )}
                                          <span
                                            className={
                                              "title--jqbwB " +
                                              ShopStyle.shapeTitle
                                            }
                                            data-value="20"
                                          >
                                            {option.name}
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </Col>
                              ) : (
                                <Col md={6}>
                                  <Form.Group
                                    className="ShowcaseRingseting_Prodselect"
                                    controlId="exampleForm.ControlInput1"
                                  >
                                    <Form.Label
                                      className={
                                        val?.title == "Ring Size" &&
                                         notify
                                          ? "rcs_details_ring_size1 selectedOptions"
                                          : "selectedOptions"
                                      }
                                    >
                                      {val?.title} :{" "}
                                      {/* {console.log('val',val)} */}
                                      <span>
                                        {val?.title == "Ring Size"
                                          ?ringSize
                                          : val?.selected}
                                      </span>
                                    </Form.Label>
                                    <div className="position-relative">
                                      <Form.Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={
                                          val?.title == "Ring Size"
                                            ?ringSize == "0"
                                              ? ""
                                              :ringSize
                                            : val?.selected
                                        }
                                        onChange={(e) => {
                                          setNotify(false);
                                          val?.title == "Ring Size"
                                            ? setRingSize(e.target.value)
                                            : onchangeselect(e.target.value, val?.title);
                                        }}
                                        label={val?.title}
                                        className={
                                          val?.title == "Ring Size" &&
                                           notify
                                            ? "rcs_details_ring_size animate__animated animate__shakeX"
                                            : "rcs_details_ring_size form-control"
                                        }
                                      >
                                        {val?.title == "Ring Size" ? (
                                          <option value= "0">Select Ring Size</option>
                                        ) : null}
                                        {val?.data?.map((option) => (
                                          <option
                                            key={option?.id}
                                            value={option?.value}
                                          >
                                            {option.name}
                                          </option>
                                        ))}
                                      </Form.Select>

                                      <svg
                                        className="downArrow"
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g opacity="0.5">
                                          <path
                                            d="M13 1L7 7L1 1"
                                            fill="white"
                                          />
                                          <path
                                            d="M13 1L7 7L1 1"
                                            stroke="var(--primary)"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </Form.Group>
                                </Col>
                              )
                            // <FormControl variant="outlined">
                            //   <InputLabel

                            //     id="demo-simple-select-outlined-label"
                            //   >

                            //   </InputLabel>
                            //   <Select
                            //     labelId="demo-simple-select-outlined-label"
                            //     id="demo-simple-select-outlined"
                            //     value={
                            //       val?.title == "Ring Size"
                            //         ?ringSize == "0"
                            //           ? ""
                            //           :ringSize
                            //         : val?.selected
                            //     }
                            //     onChange={(e) => {
                            //       setState({ notify: false });
                            //       val?.title == "Ring Size"
                            //         ? setState({ ringSize: e.target.value })
                            //         : onchangeselect(e, val?.title);
                            //     }}
                            //     label={val?.title}
                            //     className={
                            //       val?.title == "Ring Size" &&notify
                            //         ? "rcs_details_ring_size animate__animated animate__shakeX"
                            //         : "rcs_details_ring_size"
                            //     }
                            //   >

                            //   </Select>
                            // </FormControl>
                          )}
                        </Row>
                      </div>

                      <div className="rcs_product_btn">
                        <Dialog
                          onClose={handleCloseButton}
                          open={openButton}
                          className="rcs_dialog_btn1"
                        >
                          <List sx={{ pt: 0 }} className="rcs_dialog_btn m-10">
                            <Button
                              variant="contained"
                              onClick={() => {
                                history.push("/diamonds");
                                handleCloseButton();
                                selectSetting();
                              }}
                              className="rcs_add_setting_btn w-100 mb-3"
                            >
                              ADD A DIAMOND
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => {
                                history.push("/gemstones");
                                handleCloseButton();
                                selectSetting();
                              }}
                              className="rcs_add_setting_btn1 w-100 mb-3"
                            >
                              ADD A GEMSTONE
                            </Button>
                            {/* <Button
                              variant="contained"
                              onClick={() => {
                                history.push("/fancy-color-diamond");
                                handleCloseButton();
                                selectSetting();
                              }}
                              className="rcs_add_setting_btn2 w-100 mb-3"
                            >
                              ADD A FANCY DIAMOND
                            </Button> */}
                            <Button
                              variant="contained"
                              onClick={() => {
                                addtocart(
                                 productDetailsdata?.product_id,
                                  1
                                );
                                handleCloseButton();
                                selectSetting();
                              }}
                              className="rcs_add_setting_btn2 w-100 mb-3"
                            >
                              ADD TO CART
                            </Button>
                          </List>
                        </Dialog>

                        <div className="appointment-report-btn">
                          <Row>
                            <Col md={6} sm={12} xs={12} lg={6}>
                              {productDetailsdata?.enable_ecommerce ==
                                1 ? (
                                match?.id == "setting" ? (
                                  JSON.parse(
                                    localStorage.getItem("bw-gemstonedata") !=
                                    null
                                  ) ||
                                    JSON.parse(
                                      localStorage.getItem("bw-diamonddata") !=
                                      null
                                    ) ||
                                    JSON.parse(
                                      localStorage.getItem("bw-fancycolordata") !=
                                      null
                                    ) ? (
                                    <Button
                                      variant="contained"
                                      onClick={() => selectSetting()}
                                      className="rcs_border_btn w-100 bg-dark"
                                    >
                                      Add This Setting
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      onClick={() => handleOpenButton()}
                                      className="rcs_border_btn w-100 bg-dark"
                                    >
                                      Add This Setting
                                    </Button>
                                  )
                                ) : (
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      addtocart(
                                       productDetailsdata?.product_id,
                                        1
                                      )
                                    }
                                    className="rcs_border_btn w-100 bg-dark"
                                  >
                                    Add to Cart
                                  </Button>
                                )
                              ) : (
                                <Button
                                  variant="contained"
                                  className="rcs_border_btn w-100 bg-dark"
                                  onClick={() => handleShowInquiry()}
                                >
                                  Inquire
                                </Button>
                              )}
                            </Col>
                            <Col md={6} sm={12} xs={12} lg={6}>
                              <Button
                                variant="outlined"
                                className="rcs_border_btn w-100"
                                onClick={handleShowAppointment}
                              >
                                <svg
                                  width="19"
                                  height="19"
                                  viewBox="0 0 19 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.9919 2.19183L12.9927 2.78528C15.1735 2.9562 16.614 4.44221 16.6164 6.72106L16.625 13.3915C16.6281 15.8761 15.0672 17.4048 12.5652 17.4088L6.45357 17.4167C3.96719 17.4198 2.38673 15.8547 2.3836 13.363L2.37501 6.77091C2.37188 4.47702 3.76162 2.99497 5.94239 2.79478L5.9416 2.20133C5.94082 1.85317 6.19876 1.59126 6.54268 1.59126C6.8866 1.59047 7.14454 1.85159 7.14532 2.19974L7.1461 2.75363L11.789 2.7473L11.7882 2.19341C11.7874 1.84526 12.0454 1.58414 12.3893 1.58335C12.7254 1.58255 12.9912 1.84367 12.9919 2.19183ZM3.5795 7.01542L15.4135 6.99959V6.72265C15.3798 5.02141 14.5263 4.12886 12.9943 3.99593L12.9951 4.60521C12.9951 4.94545 12.7301 5.21528 12.394 5.21528C12.0501 5.21607 11.7914 4.94704 11.7914 4.60679L11.7906 3.96586L7.14766 3.97219L7.14845 4.61233C7.14845 4.95337 6.89129 5.2224 6.54737 5.2224C6.20345 5.22319 5.94473 4.95495 5.94473 4.61391L5.94395 4.00463C4.41976 4.15735 3.57638 5.05307 3.57872 6.76933L3.5795 7.01542ZM12.0649 10.6117V10.6204C12.0727 10.9844 12.3698 11.2606 12.7301 11.2527C13.0818 11.244 13.3624 10.9425 13.3546 10.5785C13.3382 10.2303 13.056 9.94628 12.7051 9.94707C12.3455 9.95499 12.0641 10.2478 12.0649 10.6117ZM12.7106 14.1645C12.351 14.1566 12.061 13.8567 12.0602 13.4928C12.0524 13.1288 12.3408 12.8273 12.7004 12.8186H12.7082C13.0756 12.8186 13.3734 13.1185 13.3734 13.4904C13.3742 13.8623 13.0771 14.1638 12.7106 14.1645ZM8.84459 10.6244C8.86023 10.9884 9.15803 11.2725 9.51758 11.2566C9.86932 11.24 10.1499 10.9393 10.1343 10.5753C10.1257 10.2193 9.83649 9.94233 9.48475 9.94312C9.1252 9.95894 8.84381 10.2604 8.84459 10.6244ZM9.52071 14.1289C9.16116 14.1448 8.86413 13.8607 8.84772 13.4967C8.84772 13.1327 9.12833 12.832 9.48788 12.8154C9.83961 12.8146 10.1296 13.0916 10.1374 13.4469C10.1538 13.8116 9.87244 14.1123 9.52071 14.1289ZM5.62426 10.6521C5.63989 11.0161 5.93769 11.3009 6.29725 11.2843C6.64898 11.2685 6.92959 10.967 6.91317 10.603C6.90536 10.247 6.61615 9.97002 6.26364 9.97081C5.90408 9.98664 5.62348 10.2881 5.62426 10.6521ZM6.30037 14.1329C5.94082 14.1495 5.6438 13.8647 5.62739 13.5007C5.6266 13.1367 5.90799 12.8352 6.26754 12.8194C6.61928 12.8186 6.90927 13.0955 6.91708 13.4516C6.9335 13.8156 6.65289 14.1171 6.30037 14.1329Z"
                                    fill="var(--primary)"
                                  />
                                </svg>
                                Schedule an Appointment
                              </Button>
                            </Col>
                            <Col md={12} sm={12} xs={12} lg={12}>
                              {productDetailsdata?.enable_engraving ==
                                1 ? (
                                <Button
                                  variant="none"
                                  className="gs_save_btn rcs_border_btn w-100 mt-3"
                                  onClick={() =>
                                      setEngravingshow(!engravingshow)
                                  }
                                >
                                  {engravingshow ? (
                                    <>
                                      {" "}
                                      Free Engraving{" "}
                                      <RemoveCircleIcon className="ml-1" />{" "}
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      Free Engraving{" "}
                                      <AddCircleIcon className="ml-1" />
                                    </>
                                  )}
                                </Button>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </div>
                        {/* <ul>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 float-left mr-1 rcs_border_btn_border" onClick={handleShowShipping}> <i class="fas fa-shipping-fast"></i> Shipping</Button></li>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 ml-1 rcs_border_btn_border" onClick={handleShowReturn}> <i class="fas fa-undo-alt"></i> Returns</Button></li>
                                                </ul> */}
                      </div>
                      {/* <div className="rcs_ring_style_type">
                                            {productDetailsdata?.attribute?.map(val =>
                                                val.title.includes('Style') ?
                                                    <p><strong>{val.title} : </strong>{val.value}</p> : ""
                                            )}
                                        </div> */}

                      {engravingshow ? (
                        <div className="gs_engraving mb-4">
                          <div className="gs_engraving_text">
                            <div className="wrapper">
                              {metalColor?.includes("Rose-Gold") ? (
                                <Image src={rose_metal} alt="engraving"></Image>
                              ) :metalColor?.includes(
                                "Yellow-Gold"
                              ) ? (
                                <Image
                                  src={yellow_metal}
                                  alt="engraving"
                                ></Image>
                              ) : (
                                <Image
                                  src={white_metal}
                                  alt="engraving"
                                ></Image>
                              )}
                              <Engraving
                                text={engraving}
                                arc={100}
                                radius={200}
                                cname={
                                 textStyle == "great_vibes"
                                    ? "gs_great_vibes"
                                    : "gs_montserrat"
                                }
                              />
                            </div>
                          </div>
                          <Row className="w-100 m-auto gs_engraving_input">
                            <Col className="p-0">
                              <TextField
                                className={
                                 eng_color &&
                                   engraving?.length
                                    ? "eng_color_fill"
                                    : "eng_color_none"
                                }
                                id="outlined-basic"
                                label="Engraving"
                                type="text"
                                variant="outlined"
                                autoComplete="off"
                                name="engraving"
                                onBlurCapture={() =>
                                  setEng_color(true)
                                }
                                value={engraving}
                                onChange={(e) => engravingfunc(e)}
                                inputProps={{
                                  maxLength: 15,
                                }}
                              />
                              {engraving?.length ? (
                                <p className="eng_sub_lbl d-flex">
                                  <CheckCircleIcon /> "{engraving}"
                                  has been added to your engraving.{" "}
                                </p>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                          <Row className="w-100 m-auto">
                            <Col className="p-0">
                              <div className="gs_engraving_text2">
                                <ul>
                                  <li
                                    onClick={() =>
                                      setTextStyle("great_vibes")
                                    }
                                    className={
                                     textStyle == "great_vibes"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span class="gs_great_vibes">Aa</span>
                                  </li>
                                  <li
                                    onClick={() =>
                                      setTextStyle("montserrat")
                                    }
                                    className={
                                     textStyle == "montserrat"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span class="gs_montserrat">Aa</span>
                                  </li>
                                </ul>
                              </div>
                              {/* <p className="mt-3">Engraved Items are now eligible for exchange and returns</p> */}
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        //  localStorage.getItem('engravingtext')?.length &&productdata?.is_engraving == 1 ? <div className="gs_engraving">
                        //     <div className="gs_engraving_text1">
                        //         <Row>
                        //             <Col xs={8} sm={6} lg={10} >
                        //                 <h2><span class={textstyle == 'great_vibes' ? "gs_great_vibes gs_great_mob" : "gs_montserrat gs_great_mob"}>{localStorage.getItem('engravingtext')}</span> <span className="icon"><CheckCircleIcon /></span></h2>
                        //             </Col>
                        //             <Col xs={4} sm={6} lg={2}>
                        //                 <p onClick={() => { setState({ engravingtext: "" }); localStorage.setItem("engravingtext", "") }}> <DeleteIcon className="eng_del_icon" /></p>
                        //             </Col>
                        //         </Row>
                        //     </div>
                        // </div> :
                        ""
                      )}
                      <ShareIcons />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <hr className="h-line" />
          </Container>
        </div>
        <div className="rcs_product_specification showcase_Ringsetting">
          <Container fluid className="showcase-container">
            <h2>Product Details</h2>
            <Row>
              <Col md={12}>
                {productDetailsdata?.attribute?.map((val) => (
                  <div className="rcs_product_specification_content">
                    <strong>{val.title} </strong> :<p>{val.value}</p>
                  </div>
                ))}
                {/* </Col> */}
                {productDetailsdata?.category_id == "2" ? (
                  // <Col xs={12} sm={10}>
                  <div className="rcs_product_specification_content">
                    <strong>Can be set with </strong> :
                    <p>
                      {productDetailsdata?.setwithmin +
                        " - " +
                       productDetailsdata?.setwithmax}
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Container>
        </div>
        <section className="rcs_product_specification rcs_related_product_section d-none">
          <Container fluid>
            <div className="rcs_related_product_title">
              <h2>You Might Also Like </h2>
            </div>

            <div className="rcs_customer_review_slider">
              <Slider
                className="rcs_customer_say_inner rcs_product_grid"
                {...settings2}
              >
                {listData?.map((val, index) => (
                  <div className="mg_nopadd">
                    <div className="rcs_product_item position-relative">
                      <div class="d-flex  hover-buttons justify-content-between">
                        {val.enable_ecommerce == 1 ? (
                          <span onClick={() => addtocart(val.product_id)}>
                            {" "}
                            <img src={cart} alt='cart' />{" "}
                          </span>
                        ) : (
                          <span
                            onClick={() => {
                              setProduct_id(val.product_id);
                              handleShowInquiry(true);
                            }}
                          >
                            {" "}
                            <img src={inquir} alt='inquir' />{" "}
                          </span>
                        )}
                        {/* <span onClick={() => quickopen(val)}> <Image src={eye} />  </span> */}
                      </div>
                      <NavLink
                        to="#"
                        onMouseOver={() =>
                          setProIndex( index + 1 )
                        }
                        onMouseLeave={() => setProIndex("")}
                        onClick={() =>{
                          setSlug(val.slug); setFilterData([])
                        }}
                      >
                        <div class="color-overlay"></div>
                        {val.product_image?.length > 1 ? (
                          <>
                            <div>
                              {proIndex == index + 1 ? (
                                <img id={val.slug} alt={val.name}
                                  onError={() =>
                                    ErrorImg("none", val.slug)
                                  } src={val.product_image[1].url} />
                              ) : (
                                <img id={val.slug} alt={val.name}
                                  onError={() =>
                                    ErrorImg("none", val.slug)
                                  } src={val.product_image[0].url} />
                              )}
                            </div>
                          </>
                        ) : (
                          <img id={val.slug} alt={val.name}
                            onError={() =>
                              ErrorImg("none", val.slug)
                            } src={val.product_image[0].url}></img>
                        )}
                      </NavLink>
                      <div className="rcs_prod_info d_space_between">
                        <div className="d-flex align-items-start pt-10">
                          <h2
                            onClick={() =>
                            {setSlug(val.slug); setFilterData([])}
                            }
                            className="rcs_list_title"
                          >
                            {val.name}
                          </h2>
                          <button class="rcs_wish_btn rcs_wish_btn_desktop">
                            {val.is_wishlist == "0" ? (
                              <FavoriteBorderIcon
                                onClick={() =>
                                  addtowishlist(val.product_id, index, 1)
                                }
                              />
                            ) : (
                              <FavoriteIcon
                                onClick={() =>
                                  addtowishlist(val.product_id, index, 1)
                                }
                                className="animate__animated animate__heartBeat"
                              />
                            )}
                            <span className="d-none">wishlist</span>
                          </button>
                        </div>
                        <p className="rcs_emailprice">
                          {val.is_price == 1
                            ? val.currency_icon + val.sale_price
                            : "Email us for Price"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Container>
        </section>
        <div className="rcs_product_specification d-none">
          {reviewData?.rating_count?.length ? (
            <div className="rcs_product_specification_top">
              <Container>
                <Row className="m-auto w-100">
                  <Col className="rcs_p0">
                    <h2>REVIEWS</h2>
                    <Row>
                      <Col xs={12} sm={6} md={7} className="rcs_p0 p-0">
                        <div className="rcs_rating_overall">
                          <h2>{reviewData?.average_rating}</h2>
                          <p className="rcs_out_of">Out of 5</p>
                        </div>
                        <div className="rcs_rating_progress">
                          <ul>
                            {reviewData?.rating_count?.map((val) => (
                              <li>
                                <p>{val.rating} Star</p>{" "}
                                <ProgressBar
                                  className="w-75"
                                  now={val.average}
                                />
                                <span>{val.count}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Col>
                      <Col xs={12} sm={6} md={5} className="p-0">
                        <div className="rcs_rating_overall_star">
                          <h3>Overall Rating</h3>
                          <Rating
                            name="read-only"
                            value={Number(
                             reviewData?.average_rating
                            )?.toFixed(0)}
                            readOnly
                          />
                        </div>
                        <div className="rcs_rating_overall_total">
                          <h3>{average}%</h3>
                          <p>
                            of recent buyers <br />
                            gave {client_name.c_name} 5 stars
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          ) : (
            ""
          )}
          <div className="rcs_product_specification_bottom pb-5">
            <Container className="rcs_p0 mt-4">
              {reviewData?.review_data?.map((val) => (
                <Row className="m-auto w-100">
                  <Col className="p-0">
                    <div className="rcs_product_specification_bottom_content">
                      <div className="media">
                        <div className="rcs_test_cotnent">
                          <span className="rcs_user_name">
                            {val.first_name[0]}
                          </span>
                        </div>
                        <div class="media-body">
                          <label class="mb-0">
                            {val.first_name} {val.last_name}
                          </label>
                          <p class="colored-stars">
                            <Rating
                              name="read-only"
                              value={val.rating}
                              readOnly
                            />
                            <small class="float-right">
                              {moment(new Date(val.created_at)).format(
                                "YYYY-MM-DD"
                              )}
                            </small>
                          </p>
                          <p class="pt-2 pr-md-30 mb-0 small">{val.review}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              ))}
              <Row className="m-auto w-100 rcs_write_review">
                <Col className="p-0">
                  <h2>SUBMIT A PRODUCT REVIEW</h2>
                  <Button
                    variant="contained"
                    className="rcs_acc_button rcs_review_btn"
                    onClick={() =>
                      user?.isLogin
                        ? handleShowReview()
                        : document.getElementById("loginbutton")?.click()
                    }
                  >
                    Write a Review
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/*Shipping Modal*/}
        {shipping ? (
          <ShippingModal
            shippingterm={shippingterm}
            handleCloseShipping={handleCloseShipping}
          />
        ) : (
          ""
        )}
        {/*Shipping Modal*/}
        {/*Inquiry Modal*/}
        {inquiry ? (
          <ProductEnquiry
            productid={productDetailsdata?.product_id}
            handleCloseInquiry={handleCloseInquiry}
          />
        ) : (
          ""
        )}
        {/*Inquiry Modal*/}
        {/*Return Modal*/}
        {returnState ? (
          <ReturnModal handleCloseReturn={handleCloseReturn} />
        ) : (
          ""
        )}
        {/*Return Modal*/}
        {/*Review Modal*/}
        <Modal show={review} onHide={handleCloseReview}>
          <Modal.Header>
            <Modal.Title>WRITE A REVIEW</Modal.Title>
            <button
              type="button"
              onClick={handleCloseReview}
              class="close"
            >
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="rcs_add_address">
              <Row>
                <Col>
                  <p>
                    Enter your information below and tell us about your
                    experience.
                  </p>
                </Col>
              </Row>
              <Form>
                <Row>
                  <Col xs={12}>
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Rating"
                      value={rating}
                      onChange={(e) =>
                        setRating(e.target.value)
                      }
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                    </TextField>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <TextField
                      id="outlined-basic"
                      multiline
                      rows={4}
                      label="Testimonial"
                      type="text"
                      variant="outlined"
                      value={comment}
                      onChange={(e) =>
                        setComment(e.target.value)
                      }
                      required
                    />
                  </Col>
                </Row>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="rcs_cancel_button mr-2"
              onClick={handleCloseReview}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="rcs_save_button"
              onClick={() => submitReview()}
            >
              Submit Testimonial
            </Button>
          </Modal.Footer>
        </Modal>
        {/*Review Modal*/}
        {/*Appointment Modal*/}
        {appointment ? (
          <ProductAppoitnment
            type="jewelry"
            id={productDetailsdata?.product_id}
            handleClose={() => setAppointment(false)}
          />
        ) : (
          ""
        )}
        {/*Appointment Modal*/}
      </>
    );
  }

export default ProductdetailsFunctionComponent;
